import React from 'react'
import { NoteField } from '../../../shared/NoteField'
import { useNotesModel, NotesProps } from './useNotesModel'

export const Notes: React.FC<NotesProps> = props => {
  const model = useNotesModel(props)

  return (
    <div className="uc-base">
      <div className="sale-note sale-note-label-line">
        <div className="flex-1">
          <NoteField
            value={model.note}
            label={model.label}
            descriptionSlot={model.supplementaryLabel}
            placeholder={model.placeholder}
            charLimit={2000}
            autoFocus={model.shouldFocus}
            onChange={model.onChange}
            onBlur={model.onBlur}
          />
        </div>
      </div>
    </div>
  )
}
